import { Length } from "$src/CGS/domain/dto/core/Length/Length";
import { LengthValueMillimeter } from "$src/CGS/domain/dto/core/Length/LengthValueMillimeter";
import { ApplianceApertureIdentifier } from "$src/CGS/domain/dto/core/bones/ApplianceApertureIdentifier";
import { InsideElementComputation } from "./InsideElementComputation";

export class InsideApplianceComputation extends InsideElementComputation {
    fixedHeight: Length = new LengthValueMillimeter(0);
    applianceApertureIdentifier?: ApplianceApertureIdentifier;

    get minHeight(): number {
        return this.getMinLength(this.fixedHeight)?.millimeter ?? super.minHeight;
    }

    get maxHeight(): number | null {
        return this.getMaxLength(this.fixedHeight)?.millimeter ?? super.maxHeight;
    }
}
